import { TFunction } from "react-i18next";
import { GraphType, MonitoringGraphData } from "@services/monitoring/types";

export const mapDatasetTitles = (
  data: MonitoringGraphData[],
  title: string,
  graphType: GraphType | undefined,
  t: TFunction
) => {
  const hasMultipleDatasets = data.length > 1;

  if (hasMultipleDatasets) {
    const isNetworkGraph = graphType === GraphType.Network;
    const firstPostfix = isNetworkGraph ? t("In") : t("Receive");
    const secondPostfix = isNetworkGraph ? t("Out") : t("Send");
    const titleEndings = [firstPostfix, secondPostfix];

    let chartData = data;

    const [dataset1, dataset2] = data;

    // took from old implementation
    // rx/_in - means receive and should be first in datasets order
    if (!dataset1.name?.includes("rx") && !dataset1.name?.includes("_in")) {
      chartData = [dataset2, dataset1];
    }

    return chartData.map((dataset, index) => ({
      ...dataset,
      name: `${title} ${titleEndings[index]}`,
    }));
  }

  return data.map((dataset) => ({
    ...dataset,
    name: title,
  }));
};
